const { getLearnPagePath } = require('../../pages/learn/utils.cjs');

const filterByPageType = (page, type) => {
  switch (type) {
    case 'category':
      return page.category;
    case 'subcategory':
      return !page.category && page.subcategory;
    case 'skill':
      return !page.category && !page.subcategory && page.skill;
    default: return false;
  }
};

const findLearnPage = (learnPages, item, type) => {
  const learnPage = learnPages
    .find(page => (page?.[type] === item) && filterByPageType(page, type));
  if (learnPage) {
    return {
      slug: learnPage.slug,
      label: learnPage.title,
      name: learnPage[type],
      active: learnPage.active,
    };
  }
  return {};
};

const getBreadcrumb = (page, skillMap, type, languageCode) => {
  const path = getLearnPagePath(languageCode, page?.active, page?.slug);
  return {
    label: page?.label || skillMap?.[type],
    url: page?.active ? path : null,
  };
};

const getBreadcrumbs = ({
  type,
  skillMap = {},
  learnPages = [],
  label,
  languageCode,
}) => {
  const categoryPage = findLearnPage(learnPages, skillMap?.category, 'category');
  const subcategoryPage = findLearnPage(learnPages, skillMap?.subcategory, 'subcategory');
  const skillPage = findLearnPage(learnPages, skillMap?.skill, 'skill');

  let breadcrumbs = {};

  switch (type) {
    case 'category': {
      breadcrumbs = {
        category: { label },
      };
      break;
    }
    case 'subcategory': {
      breadcrumbs = {
        category: getBreadcrumb(categoryPage, skillMap, 'category', languageCode),
        subcategory: { label },
      };
      break;
    }
    case 'skill': {
      breadcrumbs = {
        category: getBreadcrumb(categoryPage, skillMap, 'category', languageCode),
        subcategory: getBreadcrumb(subcategoryPage, skillMap, 'subcategory', languageCode),
        skill: { label },
      };
      break;
    }
    default:
      breadcrumbs = {
        catalog: {
          label: languageCode === 'es' ? 'Catalogo' : 'Catalog',
          url: languageCode === 'es' ? 'es/search' : 'search',
        },
        category: getBreadcrumb(categoryPage, skillMap, 'category', languageCode),
        subcategory: getBreadcrumb(subcategoryPage, skillMap, 'subcategory', languageCode),
        skill: getBreadcrumb(skillPage, skillMap, 'skill', languageCode),
        product: { label },
      };
  }

  const uniqueLabelsMap = Object.entries(breadcrumbs).reduce((acc, [skillKey, skill]) => {
    const existingSkill = acc.get(skill.label);
    if (!existingSkill || skillKey === 'product' || !existingSkill.url) {
      acc.set(skill.label, [skillKey, skill]);
    }
    return acc;
  }, new Map());
  const uniqueSkills = Object.fromEntries(uniqueLabelsMap.values());

  return uniqueSkills;
};

const getBreadcrumbsByPath = (path, pageName) => path.split('/').map((name, index, dirs) => {
  const formattedName = name.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  const item = { label: dirs.length - 1 === index ? pageName : formattedName };
  if (index < dirs.length - 1) {
    item.href = '';
    for (let i = 0; i <= index; i++) {
      item.href += `/${dirs[i]}`;
    }
  }

  return item;
});

module.exports = {
  findLearnPage,
  getBreadcrumb,
  getBreadcrumbs,
  getBreadcrumbsByPath,
};
